import { render, staticRenderFns } from "./ReportDashboard.vue?vue&type=template&id=2a209726&"
import script from "./ReportDashboard.vue?vue&type=script&lang=js&"
export * from "./ReportDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports